import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('license', { $license: 'license', $licenseExpired: 'licenseExpired' })
  },
  methods: {
    ...mapActions('license', { $getLicense: 'getLicense', $setLicense: 'setLicense' })
  }
}
